// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Raleway:400,700);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
	-moz-appearance: textfield;
  }

input::placeholder {
	font-size: small;
    font-weight: 200;
}

.error__wrapper {
	background-color: #ffffff;
	margin-top: 30px;
	padding: 0 5px 0px 5px;
	color: #ff5a5f;
	border: 1px solid #ff5a5f;
	border-radius: 4px;
	box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.12), 0px 1px 2px rgba(0, 0, 0, 0.24);
	position: relative;
  }

  .error-wrapper_left {
	display: flex;
	align-items: center;
  }

  .error__wrapper svg {
	position: absolute;
	top: 8px;
	right: 8px;
	cursor: pointer;
  }

  .error__wrapper i {
	font-size: 20px;
	position: absolute;
	top: 8px;
	left: 35px;
  }

  .error__wrapper p {
	margin-left: 30px;
	margin-right: 20px;
  }

.screen {		
	background: var(--login-screen);	
	position: relative;	
	height: 600px;
	width: 360px;
	border-radius: 3%;	
	box-shadow: 0px 0px 24px #0C0C0B;
	overflow: hidden;
}

.login__error {
	font-size: small;
	font-weight: 800;
	color: #EBB82E;
}

.screen__content {
	display: flex;
	align-items: center;
	z-index: 1;
	position: relative;	
	height: 100%;
}

.screen__background {		
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 0;
	-webkit-clip-path: inset(0 0 0 0);
	clip-path: inset(0 0 0 0);	
}

.screen__background__shape {
	transform: rotate(45deg);
	position: absolute;
}

.screen__background__shape1 {
	height: 520px;
	width: 520px;
	background: var(--login-shape1);	
	top: -50px;
	right: 120px;	
	border-radius: 0 72px 0 0;
}

.screen__background__shape2 {
	height: 220px;
	width: 220px;
	background: var(--login-shape2);	
	top: -172px;
	right: 0;	
	border-radius: 32px;
}

.screen__background__shape3 {
	height: 540px;
	width: 190px;
	background: var(--login-shape3);
	top: -24px;
	right: 0;	
	border-radius: 32px;
}

.screen__background__shape4 {
	height: 400px;
	width: 200px;
	background: var(--login-shape4);
	top: 420px;
	right: 50px;	
	border-radius: 60px;
}

.login {
	width: 320px;
	padding: 30px;
	padding-bottom: 150px;
}

.login__field {
	padding: 20px 0px;	
	position: relative;
	z-index: 1;	
}

.login__icon {
	position: absolute;
	top: 30px;
	color: #7875B5;
}

.login__input {
	border: none;
	border-bottom: 2px solid #D1D1D4;
	background: none;
	padding: 10px;
	padding-left: 24px;
	font-weight: 700;
	width: 75%;
	transition: .2s;
}

.login__input:active,
.login__input:focus,
.login__input:hover {
	outline: none;
	border-bottom-color: #E394A7;
}

.login__submit {
	background: #E7E8E8;
	font-size: 14px;
	margin-top: 30px;
	padding: 16px 20px;
	border-radius: 26px;
	border: 1px solid #D4D3E8;
	text-transform: uppercase;
	font-weight: 700;
	display: flex;
	align-items: center;
	color: var(--main-sub-color);
	box-shadow: 0px 2px 2px var(--main-sub-color);;
	cursor: pointer;
	transition: .2s;
}

.login__submit:active,
.login__submit:focus,
.login__submit:hover {
	border-color: var(--main-tertiary-color);
	outline: none;
}

.login__field_btn_select {
	display: flex;
	justify-content: space-between;
	padding-bottom: 150px;
}

/* CSS */
.role-btn {
  background: #E7E8E8;
  backface-visibility: hidden;
  border-radius: .375rem;
  width: 35%;
  border-style: solid;
  border-width: .125rem;
  box-sizing: border-box;
  color: var(--main-sub-color);
  cursor: pointer;
  display: inline-block;
  font-family: "HelveticaNeue-Light", "Helvetica Neue Light", "Helvetica Neue", 
  Helvetica, Arial, "Lucida Grande", sans-serif;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: -.01em;
  line-height: 1.3;
  padding: .575rem 1rem;
  position: relative;
  text-align: left;
  text-decoration: none;
  transform: translateZ(0) scale(1);
  transition: transform .2s;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
}

.role-btn:not(:disabled):hover {
  transform: scale(1.05);
}

.role-btn:not(:disabled):hover:active {
  transform: scale(1.05) translateY(.125rem);
}

.role-btn:focus {
  outline: 0 solid transparent;
}

.role-btn:focus:before {
  content: "";
  left: calc(-1*.375rem);
  pointer-events: none;
  position: absolute;
  top: calc(-1*.375rem);
  transition: border-radius;
  user-select: none;
}

.role-btn:focus:not(:focus-visible) {
  outline: 0 solid transparent;
}

.role-btn:focus:not(:focus-visible):before {
  border-width: 0;
}

.role-btn:not(:disabled):active {
  transform: translateY(.125rem);
}

@media only screen and (max-width: 600px) {
	.screen {		
		height: 550px;
		width: 360px;
	}
	
	.login {
		width: 320px;
		padding: 15px;
	}
	.login__field_btn_select {
		padding-bottom: 100px;
	}
  }`, "",{"version":3,"sources":["webpack://./src/components/form/form.css"],"names":[],"mappings":"AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,YAAY;AACZ;CACC,0BAA0B;EACzB;;AAEF;CACC,gBAAgB;IACb,gBAAgB;AACpB;;AAEA;CACC,yBAAyB;CACzB,gBAAgB;CAChB,sBAAsB;CACtB,cAAc;CACd,yBAAyB;CACzB,kBAAkB;CAClB,4EAA4E;CAC5E,kBAAkB;EACjB;;EAEA;CACD,aAAa;CACb,mBAAmB;EAClB;;EAEA;CACD,kBAAkB;CAClB,QAAQ;CACR,UAAU;CACV,eAAe;EACd;;EAEA;CACD,eAAe;CACf,kBAAkB;CAClB,QAAQ;CACR,UAAU;EACT;;EAEA;CACD,iBAAiB;CACjB,kBAAkB;EACjB;;AAEF;CACC,+BAA+B;CAC/B,kBAAkB;CAClB,aAAa;CACb,YAAY;CACZ,iBAAiB;CACjB,gCAAgC;CAChC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;CAChB,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,UAAU;CACV,kBAAkB;CAClB,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,QAAQ;CACR,SAAS;CACT,UAAU;CACV,iCAAiC;CACjC,yBAAyB;AAC1B;;AAEA;CACC,wBAAwB;CACxB,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,YAAY;CACZ,+BAA+B;CAC/B,UAAU;CACV,YAAY;CACZ,yBAAyB;AAC1B;;AAEA;CACC,aAAa;CACb,YAAY;CACZ,+BAA+B;CAC/B,WAAW;CACX,QAAQ;CACR,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,YAAY;CACZ,+BAA+B;CAC/B,UAAU;CACV,QAAQ;CACR,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,YAAY;CACZ,+BAA+B;CAC/B,UAAU;CACV,WAAW;CACX,mBAAmB;AACpB;;AAEA;CACC,YAAY;CACZ,aAAa;CACb,qBAAqB;AACtB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;CAClB,UAAU;AACX;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,cAAc;AACf;;AAEA;CACC,YAAY;CACZ,gCAAgC;CAChC,gBAAgB;CAChB,aAAa;CACb,kBAAkB;CAClB,gBAAgB;CAChB,UAAU;CACV,eAAe;AAChB;;AAEA;;;CAGC,aAAa;CACb,4BAA4B;AAC7B;;AAEA;CACC,mBAAmB;CACnB,eAAe;CACf,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;CACnB,yBAAyB;CACzB,yBAAyB;CACzB,gBAAgB;CAChB,aAAa;CACb,mBAAmB;CACnB,4BAA4B;CAC5B,6CAA6C;CAC7C,eAAe;CACf,eAAe;AAChB;;AAEA;;;CAGC,wCAAwC;CACxC,aAAa;AACd;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,qBAAqB;AACtB;;AAEA,QAAQ;AACR;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,sBAAsB;EACtB,UAAU;EACV,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,4BAA4B;EAC5B,eAAe;EACf,qBAAqB;EACrB;+CAC6C;EAC7C,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,iCAAiC;EACjC,yBAAyB;EACzB,iBAAiB;EACjB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;CACC;EACC,aAAa;EACb,YAAY;CACb;;CAEA;EACC,YAAY;EACZ,aAAa;CACd;CACA;EACC,qBAAqB;CACtB;EACC","sourcesContent":["@import url('https://fonts.googleapis.com/css?family=Raleway:400,700');\r\n\r\ninput::-webkit-outer-spin-button,\r\ninput::-webkit-inner-spin-button {\r\n  -webkit-appearance: none;\r\n  margin: 0;\r\n}\r\n\r\n/* Firefox */\r\ninput[type=number] {\r\n\t-moz-appearance: textfield;\r\n  }\r\n\r\ninput::placeholder {\r\n\tfont-size: small;\r\n    font-weight: 200;\r\n}\r\n\r\n.error__wrapper {\r\n\tbackground-color: #ffffff;\r\n\tmargin-top: 30px;\r\n\tpadding: 0 5px 0px 5px;\r\n\tcolor: #ff5a5f;\r\n\tborder: 1px solid #ff5a5f;\r\n\tborder-radius: 4px;\r\n\tbox-shadow: 0px 1px 3px rgba(0, 0, 0, 0.12), 0px 1px 2px rgba(0, 0, 0, 0.24);\r\n\tposition: relative;\r\n  }\r\n\r\n  .error-wrapper_left {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n  }\r\n\r\n  .error__wrapper svg {\r\n\tposition: absolute;\r\n\ttop: 8px;\r\n\tright: 8px;\r\n\tcursor: pointer;\r\n  }\r\n\r\n  .error__wrapper i {\r\n\tfont-size: 20px;\r\n\tposition: absolute;\r\n\ttop: 8px;\r\n\tleft: 35px;\r\n  }\r\n\r\n  .error__wrapper p {\r\n\tmargin-left: 30px;\r\n\tmargin-right: 20px;\r\n  }\r\n\r\n.screen {\t\t\r\n\tbackground: var(--login-screen);\t\r\n\tposition: relative;\t\r\n\theight: 600px;\r\n\twidth: 360px;\r\n\tborder-radius: 3%;\t\r\n\tbox-shadow: 0px 0px 24px #0C0C0B;\r\n\toverflow: hidden;\r\n}\r\n\r\n.login__error {\r\n\tfont-size: small;\r\n\tfont-weight: 800;\r\n\tcolor: #EBB82E;\r\n}\r\n\r\n.screen__content {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tz-index: 1;\r\n\tposition: relative;\t\r\n\theight: 100%;\r\n}\r\n\r\n.screen__background {\t\t\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\tleft: 0;\r\n\tright: 0;\r\n\tbottom: 0;\r\n\tz-index: 0;\r\n\t-webkit-clip-path: inset(0 0 0 0);\r\n\tclip-path: inset(0 0 0 0);\t\r\n}\r\n\r\n.screen__background__shape {\r\n\ttransform: rotate(45deg);\r\n\tposition: absolute;\r\n}\r\n\r\n.screen__background__shape1 {\r\n\theight: 520px;\r\n\twidth: 520px;\r\n\tbackground: var(--login-shape1);\t\r\n\ttop: -50px;\r\n\tright: 120px;\t\r\n\tborder-radius: 0 72px 0 0;\r\n}\r\n\r\n.screen__background__shape2 {\r\n\theight: 220px;\r\n\twidth: 220px;\r\n\tbackground: var(--login-shape2);\t\r\n\ttop: -172px;\r\n\tright: 0;\t\r\n\tborder-radius: 32px;\r\n}\r\n\r\n.screen__background__shape3 {\r\n\theight: 540px;\r\n\twidth: 190px;\r\n\tbackground: var(--login-shape3);\r\n\ttop: -24px;\r\n\tright: 0;\t\r\n\tborder-radius: 32px;\r\n}\r\n\r\n.screen__background__shape4 {\r\n\theight: 400px;\r\n\twidth: 200px;\r\n\tbackground: var(--login-shape4);\r\n\ttop: 420px;\r\n\tright: 50px;\t\r\n\tborder-radius: 60px;\r\n}\r\n\r\n.login {\r\n\twidth: 320px;\r\n\tpadding: 30px;\r\n\tpadding-bottom: 150px;\r\n}\r\n\r\n.login__field {\r\n\tpadding: 20px 0px;\t\r\n\tposition: relative;\r\n\tz-index: 1;\t\r\n}\r\n\r\n.login__icon {\r\n\tposition: absolute;\r\n\ttop: 30px;\r\n\tcolor: #7875B5;\r\n}\r\n\r\n.login__input {\r\n\tborder: none;\r\n\tborder-bottom: 2px solid #D1D1D4;\r\n\tbackground: none;\r\n\tpadding: 10px;\r\n\tpadding-left: 24px;\r\n\tfont-weight: 700;\r\n\twidth: 75%;\r\n\ttransition: .2s;\r\n}\r\n\r\n.login__input:active,\r\n.login__input:focus,\r\n.login__input:hover {\r\n\toutline: none;\r\n\tborder-bottom-color: #E394A7;\r\n}\r\n\r\n.login__submit {\r\n\tbackground: #E7E8E8;\r\n\tfont-size: 14px;\r\n\tmargin-top: 30px;\r\n\tpadding: 16px 20px;\r\n\tborder-radius: 26px;\r\n\tborder: 1px solid #D4D3E8;\r\n\ttext-transform: uppercase;\r\n\tfont-weight: 700;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tcolor: var(--main-sub-color);\r\n\tbox-shadow: 0px 2px 2px var(--main-sub-color);;\r\n\tcursor: pointer;\r\n\ttransition: .2s;\r\n}\r\n\r\n.login__submit:active,\r\n.login__submit:focus,\r\n.login__submit:hover {\r\n\tborder-color: var(--main-tertiary-color);\r\n\toutline: none;\r\n}\r\n\r\n.login__field_btn_select {\r\n\tdisplay: flex;\r\n\tjustify-content: space-between;\r\n\tpadding-bottom: 150px;\r\n}\r\n\r\n/* CSS */\r\n.role-btn {\r\n  background: #E7E8E8;\r\n  backface-visibility: hidden;\r\n  border-radius: .375rem;\r\n  width: 35%;\r\n  border-style: solid;\r\n  border-width: .125rem;\r\n  box-sizing: border-box;\r\n  color: var(--main-sub-color);\r\n  cursor: pointer;\r\n  display: inline-block;\r\n  font-family: \"HelveticaNeue-Light\", \"Helvetica Neue Light\", \"Helvetica Neue\", \r\n  Helvetica, Arial, \"Lucida Grande\", sans-serif;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  letter-spacing: -.01em;\r\n  line-height: 1.3;\r\n  padding: .575rem 1rem;\r\n  position: relative;\r\n  text-align: left;\r\n  text-decoration: none;\r\n  transform: translateZ(0) scale(1);\r\n  transition: transform .2s;\r\n  user-select: none;\r\n  -webkit-user-select: none;\r\n  touch-action: manipulation;\r\n}\r\n\r\n.role-btn:not(:disabled):hover {\r\n  transform: scale(1.05);\r\n}\r\n\r\n.role-btn:not(:disabled):hover:active {\r\n  transform: scale(1.05) translateY(.125rem);\r\n}\r\n\r\n.role-btn:focus {\r\n  outline: 0 solid transparent;\r\n}\r\n\r\n.role-btn:focus:before {\r\n  content: \"\";\r\n  left: calc(-1*.375rem);\r\n  pointer-events: none;\r\n  position: absolute;\r\n  top: calc(-1*.375rem);\r\n  transition: border-radius;\r\n  user-select: none;\r\n}\r\n\r\n.role-btn:focus:not(:focus-visible) {\r\n  outline: 0 solid transparent;\r\n}\r\n\r\n.role-btn:focus:not(:focus-visible):before {\r\n  border-width: 0;\r\n}\r\n\r\n.role-btn:not(:disabled):active {\r\n  transform: translateY(.125rem);\r\n}\r\n\r\n@media only screen and (max-width: 600px) {\r\n\t.screen {\t\t\r\n\t\theight: 550px;\r\n\t\twidth: 360px;\r\n\t}\r\n\t\r\n\t.login {\r\n\t\twidth: 320px;\r\n\t\tpadding: 15px;\r\n\t}\r\n\t.login__field_btn_select {\r\n\t\tpadding-bottom: 100px;\r\n\t}\r\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
